import { createFragmentContainer, graphql } from "react-relay";

import TeamLabels from "~/components/Teams/Labels";
import Emojify from "~/components/shared/Emojify";

type Props = {
  team: {
    name: string;
    description?: string;
    slug: string;
  };
};

const TeamSuggestion = ({ team }: Props) => (
  <div>
    <div className="flex items-center">
      <Emojify text={team.name} className="semi-bold max-w-full truncate" />
      <TeamLabels team={team} />
    </div>
    <div className="dark-gray m-0 max-w-full truncate p-0">
      <Emojify text={team.description || "n/a"} />
    </div>
  </div>
);

export default createFragmentContainer(TeamSuggestion, {
  team: graphql`
    fragment TeamSuggestion_team on Team {
      name
      description
      slug
      ...Labels_team
    }
  `,
});
